export function bindAll(scope, selector, event, handler) { 
  scope.querySelectorAll(selector).forEach(el => {    
    el.addEventListener(event, handler)
  })
}
